/**
 * @generated SignedSource<<857c2638fd8131352864d77dbbcc21dd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type SprintGroupHeader$data = {
  readonly displayName: string;
  readonly sprint: {
    readonly state: JiraSprintState | null | undefined;
  };
  readonly " $fragmentType": "SprintGroupHeader";
};
export type SprintGroupHeader$key = {
  readonly " $data"?: SprintGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"SprintGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "SprintGroupHeader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "concreteType": "JiraSprint",
      "kind": "LinkedField",
      "name": "sprint",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "state"
        }
      ]
    }
  ],
  "type": "JiraJqlSprintFieldValue"
};

(node as any).hash = "c2d9817a445caaca4793868218a63862";

export default node;
